import Page from "layouts/Page";
import {
  Divider,
  Heading,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Center,
  useDisclosure,
  Collapse,
  Flex,
} from "@chakra-ui/react";
import Image from "next/image";
import { ChevronDown, ChevronUp } from "react-feather";

const Question = ({ title, id, children }) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Box
      bg="white"
      p={6}
      my={6}
      borderRadius="xl"
      boxShadow={"xl"}
      onClick={onToggle}
      cursor="pointer"
      id={id ?? null}
    >
      <Flex color="brand.500" justify={"space-between"}>
        <Heading fontSize={"xl"}>{title}</Heading>
        {isOpen ? <ChevronUp /> : <ChevronDown />}
      </Flex>
      <Collapse in={isOpen} animateOpacity>
        <Box pb={4}>{children}</Box>
      </Collapse>
    </Box>
  );
};

export default function () {
  return (
    <Page>
      <article>
        <Heading>FAQ</Heading>
        <Divider />
        <Question title="Qu’est-ce que Tête en l’Air ?" id="concept">
          <p>
            Tête en l'air est une plateforme mettant en relation des voyageurs
            aériens avec des photographes passionnés d'aviation (spotters),
            prêts à capturer leur vol en image. <br />
            Les voyageurs peuvent ainsi repartir avec un cliché unique de votre
            décollage ou de votre atterrissage. Les photographes sont rémunérés
            sur chaque photographie réalisée.
          </p>
        </Question>
        <Question title="Comment ça fonctionne ?" id="fonctionnemnet">
          <p>
            En précisant vos informations de vol ainsi que votre adresse mail,
            vous créez une demande qui va parvenir aux photographes basés à
            l’aéroport que vous avez renseigné dans le formulaire.
            <br />
            Les photographes alertés auront le choix d’accepter ou non la
            demande.
            <br />
            Si la demande a été acceptée, vous n’avez plus qu’à attendre votre
            vol. Dès lors que le photographe a pris votre appareil en photo,
            nous nous engageons à vous fournir la photo dans les meilleurs
            délais. <br />
            Tête en l’Air garanti des prises de vue d’une qualité
            professionnelle.
          </p>
        </Question>
        <Question title="Comment contacter l'équipe ?" id="contact">
          <p>
            Si vous avez des questions à propos de notre plateforme, rencontrez
            un problème ou bien souhaitez signaler un dysfonctionnement merci de
            nous envoyer un mail à l'adresse suivante :{" "}
            <a className="link" href="mailto:contact@tete-en-lair.fr">
              contact@tete-en-lair.fr
            </a>
          </p>
        </Question>
        <section>
          <Heading mt={8} fontSize={"2xl"}>
            Je suis client
          </Heading>
        </section>
        <Question title="Combien ça coûte ?" id="prix">
          <p>
            Le tarif d'une photo est de 10€. Dans ce tarif, nous récupérons 30%
            qui nous permet de payer les cotisations sociales et maintenir le
            site en ligne. Le reste est reversé au photographe.
            <br />
            Concernant la plateforme qui effectue la transaction, nous avons
            choisi Stripe. Stripe respecte les normes de certification les plus
            strictes afin de réduire les efforts de mise en conformité pour
            assurer la sécurité des paiements.
            <br />
            Plus d'informations à propos de Stripe ici :{" "}
            <a href="https://stripe.com/fr/payments" target="_blank" rel="noopener noreferrer">
              https://stripe.com/fr/payments
            </a>
          </p>
          <Center mt={8}>
            <Image src={"/images/pie_chart.png"} height={142} width={142} />
          </Center>
        </Question>
        <Question
          title="Et si ma demande n’a pas pu être honorée ?"
          id="commande-non-honoree"
        >
          <p>
            Notre communauté de photographes rassemble des passionnés qui
            effectuent ces prises de vues sur leur temps libre. Selon les
            horaires ainsi que la date de votre vol, il se peut que personne ne
            soit disponible. Plusieurs facteurs (météo, vol de nuit, nombre de
            photographes basé à l’aéroport, changement de configuration) peuvent
            conduire les photographes à ne pas pouvoir honorer une demande.
          </p>
        </Question>
        <Question
          title="Comment est-ce que je récupère ma photo ?"
          id="recuperer-photo"
        >
          <p>
            Lorsque votre photo est prête, vous recevrez un mail qui vous
            redirigera vers notre plateforme de paiement. Une fois le paiement
            effectué, vous serez redirigé vers notre plateforme de partage de
            fichiers sécurisée d’où vous pourrez télécharger votre photo au
            format .jpg (JPEG). L’accès à cet espace vous est garanti pendant un
            mois à compter de l’émission du mail. Au-delà de ce délai, vous
            pouvez contacter notre équipe afin de pouvoir récupérer votre cliché
            à :{" "}
            <a href="mailto:contact@tete-en-lair.fr">contact@tete-en-lair.fr</a>
          </p>
        </Question>
        <Question title="Puis-je partager ma photo ?" id="partage-photo">
          <p>
            Lorsque vous réglez le paiement de votre cliché, vous acceptez le
            contrat de License de Droits d’auteur qui vous est adressé.
            <br />
            <br />
            Selon les conditions générales, vous avez le droit de fixer l'oeuvre
            par toute technique sur tout support et notamment : <br />
            <br />
            Support en ligne, en ce compris la communication par Internet et
            réseaux informatiques. Droit limité aux simples représentations.
            L’ajout de l’œuvre dans un contexte pouvant apporter une confusion
            entre le licencié et l’auteur de l’œuvre n’est pas autorisé
            (JetPhotos, AirplanePictures, Airfleets).
            <br />
            <br />
            Plus d’informations à propos de la Licence de droits d’auteur ici :{" "}
            <a
              className="link"
              href="https://www.captaincontrat.com/protection-des-creations/proteger-ses-creations/cession-droits/"
              target="_blank"
            >
              https://www.captaincontrat.com/protection-des-creations/proteger-ses-creations/cession-droits/
            </a>
            <br />
            <br />
            L'autorisation de reproduire sur Internet comprend également
            l'autorisation d'établir tout lien à partir ou en direction de
            l’Auteur qui a produit l'Œuvre.
            <br />
            <br />
            Il est interdit de reproduire l'oeuvre dans le cadre public ou à but
            commercial. <br />
            <br />
            Le photographe ainsi que Tête en l’Air n’accorde aucune rémunération
            de la part du licencié en vue de la cession de la licence. Le
            licencié ne doit, sous aucune forme et sous aucun moyen, pouvoir
            percevoir une rémunération directe ou indirecte de l’œuvre qui lui a
            été cédée.
          </p>
        </Question>
        <section>
          <Heading fontSize={"2xl"}>Je suis spotter</Heading>
        </section>
        <Question title="Qu’en est-il des droits d’auteur ?" id="droits-auteur">
          <p>
            Le respect des droits d’auteur est fondamental chez Tête en l’Air.
            Lorsque votre photo est transmise et réglée par le client, un
            contrat de License de Droits d’auteur est créé entre vous et le
            client.
            <br />
            <br />
            En clair vous conservez la propriété et les droits d’auteur sur
            votre œuvre. Le licencié possède quelques droits d’utilisation. Pour
            en savoir plus, vous pouvez consulter le contrat de License de
            Droits d’auteur.
            <br />
            <br />
            Plus d’informations à propos de la Licence de droits d’auteur ici :{" "}
            <a
              className="link"
              href="https://www.captaincontrat.com/protection-des-creations/proteger-ses-creations/cession-droits/"
              target="_blank"
            >
              https://www.captaincontrat.com/protection-des-creations/proteger-ses-creations/cession-droits/
            </a>
          </p>
        </Question>
        <Question
          title="Et si je n’arrive pas à honorer ma commande ?"
          id="commande-impossible"
        >
          <p>
            Il peut vous arriver de ne pas pouvoir honorer une commande que vous
            avez précédemment validée. Afin de ne plus être associé à la
            demande, annulez-la simplement depuis votre espace, aucune
            justification ne vous sera demandée. Sachez qu’en cas d’abus, vous
            pourrez être suspendus et ne pourrez accepter de demandes sur une
            période limitée. Vous serez mis en contact avec notre équipe afin de
            pouvoir réactiver votre compte.
          </p>
        </Question>
        <Question title="Comment percevoir ma rémunération ?" id="remuneration">
          <p>
            Vous percevrez votre rémunération dès lors que le client a réglé le
            paiement de votre photo. Comptez environ une semaine avant de
            retrouver votre paiement sur votre compte en banque.
          </p>
        </Question>
        <Question
          title="Et si plusieurs photographes sont présents sur une même demande ?"
          id="plusieurs-photographes"
        >
          <p>
            Si une demande de photographie a été émise et que plusieurs
            photographes sont sur la même demande, c’est le premier arrivé qui
            sera le premier servi. Si le premier photographe ne peut livrer sa
            photo dans les temps, alors le second sera prioritaire.
          </p>
        </Question>
        <Question
          title="Je suis mineur. Puis-je m’inscrire ?"
          id="inscription-mineur"
        >
          <p>
            Vous pouvez vous inscrire ! Malgré ça, vous ne pourrez percevoir vos
            revenus en fin de mois comme convenu. Vos rémunérations vous seront
            versées dès que vous aurez atteint la majorité.
          </p>
        </Question>
        <Question title="Dois-je déclarer mes revenus aux impôts ?" id="impots">
          <p>
            L’économie collaborative est en plein essor et la loi s’adapte en
            apportant continuellement des précisions sur les comportements à
            adopter à la fois pour les utilisateurs et les propriétaires des
            plateformes.
            <br />
            <br />
            De notre côté, conformément à l’article 242 bis du code général des
            impôts, nous avons l’obligation de déclarer tout revenu généré par
            nos utilisateurs au-delà d’un seuil de 3 000€ par an.
            <br />
            <br />
            En tant qu'utilisateur et contribuable français, c'est à vous
            d'apprécier ou non de devoir déclarer vos revenus dès le premier
            euro, comme vous le feriez pour du covoiturage, de la vente d'objets
            d'occasion ou encore du baby-sitting. Nous vous envoyons chaque
            année, au mois de janvier, un récapitulatif de vos transactions sur
            l'année n-1 pour vous permettre de déterminer ces revenus.
            <br />
            <br />
            Pour en savoir plus sur les obligations fiscales et sociales qui
            peuvent s’appliquer à vos transactions, nous vous invitons à
            consulter les liens suivants :
          </p>
          <ul>
            <li>
              Obligations fiscales :{" "}
              <a
                href="https://www.impots.gouv.fr/portail/node/10841"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.impots.gouv.fr/portail/node/10841
              </a>
            </li>
            <li>
              Obligations sociales :{" "}
              <a
                href="https://www.urssaf.fr/portail/home/espaces-dedies/activites-relevant-de-leconomie.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.urssaf.fr/portail/home/espaces-dedies/activites-relevant-de-leconomie.html
              </a>
            </li>
          </ul>
          <p>
            Sachez que le non-respect de vos obligations fiscales peut être
            soumis à des sanctions par les administrations. Pour plus
            d’informations, consultez le lien suivant :{" "}
            <a
              href="https://www.economie.gouv.fr/particuliers/economie-collaborative-revenus-imposables"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.economie.gouv.fr/particuliers/economie-collaborative-revenus-imposables
            </a>
          </p>
        </Question>
      </article>
    </Page>
  );
}
